import { useEffect } from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'


const decorators = [
  memoized,
]

function BodyScrollBlocker() {
  useEffect(() => {
    document.body.classList.add('block-scroll')
    return () => {
      document.body.classList.remove('block-scroll')
    }
  })

  return null
}

BodyScrollBlocker = chainDecorators(decorators, BodyScrollBlocker)

export default BodyScrollBlocker
